import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-57e09eb6")

_pushScopeId("data-v-57e09eb6")
const _hoisted_1 = { class: "security-alert" }
const _hoisted_2 = {
  class: "notice",
  role: "dialog",
  "aria-labelledby": "notice-title"
}
const _hoisted_3 = { class: "notice-header" }
const _hoisted_4 = { class: "brand" }
const _hoisted_5 = { id: "notice-title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  class: "shield",
  viewBox: "0 0 48 56",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M24 3 44 10v17c0 12-9 20-20 26C13 47 4 39 4 27V10L24 3Z",
    stroke: "currentColor",
    "stroke-width": "3"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "m15 27 6 6 12-13",
    stroke: "currentColor",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = { class: "notice-body" }
const _hoisted_8 = { class: "notice-intro" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  class: "hint-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M12 3 20 6v6c0 5-4 8-8 10-4-2-8-5-8-10V6l8-3Z" }),
  /*#__PURE__*/_createVNode("path", { d: "M12 8v5m0 4h.01" })
], -1)
const _hoisted_10 = { class: "warning intro-warning" }
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  class: "warning-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M10.3 4.3a2 2 0 0 1 3.4 0l8 13.7a2 2 0 0 1-1.7 3H4a2 2 0 0 1-1.7-3l8-13.7Z",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12 9v5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "12",
    cy: "17",
    r: "1",
    fill: "currentColor"
  })
], -1)
const _hoisted_12 = { class: "columns" }
const _hoisted_13 = {
  class: "accounts",
  "aria-labelledby": "accounts-title"
}
const _hoisted_14 = { id: "accounts-title" }
const _hoisted_15 = { class: "account-cards" }
const _hoisted_16 = { class: "account-card-top" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", {
  class: "account-icon",
  "aria-hidden": "true"
}, "✦", -1)
const _hoisted_18 = { class: "account-platform" }
const _hoisted_19 = { class: "account-badge" }
const _hoisted_20 = { class: "account-number" }
const _hoisted_21 = { class: "account-name" }
const _hoisted_22 = { class: "service-warning" }
const _hoisted_23 = /*#__PURE__*/_createVNode("svg", {
  class: "megaphone",
  viewBox: "0 0 28 30",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M5 12 21 5v20L5 18v-6ZM5 12H2v6h3m3 2 2 8h4l-2-6M25 11v8",
    "stroke-linejoin": "round",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_24 = {
  class: "verification",
  "aria-labelledby": "verification-title"
}
const _hoisted_25 = { id: "verification-title" }
const _hoisted_26 = /*#__PURE__*/_createVNode("svg", {
  class: "hint-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "10",
    cy: "10",
    r: "7"
  }),
  /*#__PURE__*/_createVNode("path", { d: "m15 15 6 6m-14-11 2 2 4-4" })
], -1)
const _hoisted_27 = {
  class: "verification-link",
  href: "https://www.yz6699.com",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_28 = { class: "verification-label" }
const _hoisted_29 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createVNode("ellipse", {
    cx: "12",
    cy: "12",
    rx: "4",
    ry: "10"
  }),
  /*#__PURE__*/_createVNode("path", { d: "M2 12h20M4 6.5h16M4 17.5h16" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("strong", null, "www.yz6699.com", -1)
const _hoisted_31 = { class: "warning final-warning" }
const _hoisted_32 = /*#__PURE__*/_createVNode("svg", {
  class: "warning-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M10.3 4.3a2 2 0 0 1 3.4 0l8 13.7a2 2 0 0 1-1.7 3H4a2 2 0 0 1-1.7-3l8-13.7Z",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M12 9v5",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createVNode("circle", {
    cx: "12",
    cy: "17",
    r: "1",
    fill: "currentColor"
  })
], -1)
const _hoisted_33 = { class: "notice-footer" }
const _hoisted_34 = {
  class: "button primary",
  href: "https://www.yz6699.com",
  target: "_blank",
  rel: "noopener noreferrer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("header", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.iN('securitynotice.brand')), 1),
        _createVNode("h1", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.iN('securitynotice.title')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("p", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.iN('securitynotice.intro')), 1)
        ]),
        _createVNode("p", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", null, _toDisplayString(_ctx.iN('securitynotice.introWarning')), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("section", _hoisted_13, [
            _createVNode("h2", _hoisted_14, _toDisplayString(_ctx.iN('securitynotice.accountsTitle')), 1),
            _createVNode("div", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accounts, (item) => {
                return (_openBlock(), _createBlock("article", {
                  class: "account-card",
                  key: item.id
                }, [
                  _createVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode("span", _hoisted_18, _toDisplayString(_ctx.iN('securitynotice.accountPlatform')), 1),
                    _createVNode("span", _hoisted_19, _toDisplayString(_ctx.iN('securitynotice.accountBadge')), 1)
                  ]),
                  _createVNode("strong", _hoisted_20, _toDisplayString(item.id), 1),
                  _createVNode("p", _hoisted_21, _toDisplayString(_ctx.iN('securitynotice.accountName')), 1)
                ]))
              }), 128))
            ]),
            _createVNode("p", _hoisted_22, [
              _hoisted_23,
              _createVNode("span", null, _toDisplayString(_ctx.iN('securitynotice.serviceWarning')), 1)
            ])
          ]),
          _createVNode("section", _hoisted_24, [
            _createVNode("h2", _hoisted_25, _toDisplayString(_ctx.iN('securitynotice.verifyTitle')), 1),
            _createVNode("p", null, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.iN('securitynotice.verifyHint')), 1)
            ]),
            _createVNode("a", _hoisted_27, [
              _createVNode("span", _hoisted_28, [
                _hoisted_29,
                _createTextVNode(" " + _toDisplayString(_ctx.iN('securitynotice.verifyPlatform')), 1)
              ]),
              _hoisted_30
            ]),
            _createVNode("p", _hoisted_31, [
              _hoisted_32,
              _createVNode("span", null, _toDisplayString(_ctx.iN('securitynotice.finalWarning')), 1)
            ])
          ])
        ])
      ]),
      _createVNode("footer", _hoisted_33, [
        _createVNode("a", _hoisted_34, _toDisplayString(_ctx.iN('securitynotice.verifyNow')), 1),
        _createVNode("button", {
          class: "button secondary",
          type: "button",
          disabled: _ctx.closeCountdown > 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
        }, _toDisplayString(_ctx.closeLabel), 9, ["disabled"])
      ])
    ])
  ]))
})